export enum DashboardTab {
  Active = 'active',
  Archived = 'archived'
}

export enum NlpTrainingSection {
  IGNORED = 'Ignored',
  UNMATCHED = 'Unmatched'
}

export enum KnowledgeBaseEditorSection {
  QUERIES = 'Queries',
  PROMPT = 'Prompt',
  DOCUMENTS = 'Knowledge'
}

export enum ChatEditorSection {
  QUERIES = 'Queries',
  PROMPT = 'Prompt'
}
